import React, { ChangeEvent, useEffect } from 'react';
import { BankItemProps } from '..';
import './_styles.scss';
import { useStateReducer } from '../../../../hooks';
import Heading from '../../../../_global/components/heading/Heading';
import { Form } from '../../../../components';
import { InstructionWrapper, TextField } from '../../../../components/fields';
import { publish } from '../../../../hooks';
import { StateTopicEnum } from '../../../../enums';
import { Regexes } from '../../../../definitions';
import { validateObject } from '../../../../utilities';

export default function EditItem({
  data: { _id, code, mx_code, name, rank }
}: BankItemProps) {
  const [state, setState] = useStateReducer({
    name,
    code,
    rank,
    mx_code,
    _id
  });

  const handleState = (key: string, value: any) => {
    setState({ ...state, [key]: value });

    publish(StateTopicEnum.EditItem, state);
    publish(StateTopicEnum.IsValid, isValid());
  };

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    key: string
  ) => {
    let value: string | boolean = event.currentTarget.value;

    setState({ [key]: value });
  };

  const isValid = () => {
    if (errors['name']) return false;
    if (errors['code']) return false;
    if (errors['rank']) return false;
    if (errors['mx_code']) return false;
    return true;
  };

  const errors = validateObject(
    {
      name: {
        regex: Regexes.anyContentRegex,
        message: 'Bank Name is required.'
      },
      rank: {
        regex: Regexes.anyContentRegex,
        message: 'Rank is required.'
      },
      code: {
        regex: Regexes.anyContentRegex,
        message: 'Code is required.'
      },
      mx_code: {
        regex: Regexes.anyContentRegex,
        message: 'mx code is required.'
      }
    },
    state
  );

  useEffect(() => {
    publish(StateTopicEnum.IsValid, isValid());
    publish(StateTopicEnum.EditItem, { ...state });
    // eslint-disable-next-line
  }, [
    state.name,
    state.code,
    state.rank,
    state.mx_code
  ]);

  return (
    <div id='bank-edit-item'>
      <Heading name={ name } />
        <Form title='Bank Details'>
          <InstructionWrapper
            text='Enter the banks name and rank here.'
            error={errors['name'] || errors['rank']}
            row
          >
            <TextField
              label='Bank Name'
              value={state.name}
              onChange={(event) => handleChange(event, 'name')}
              error={!!errors['name']}
            />
            <TextField
              label='Rank'
              key='rank'
              type={'number'}
              value={state.rank}
              onChange={(event) => handleChange(event, 'rank')}
              error={!!errors['rank']}
            />
          </InstructionWrapper>
          <InstructionWrapper
            text='Enter the bank code and mx_code.'
            error={errors['code'] || errors['mx_code']}
            row
          >
            <TextField
              label='Code'
              value={state.code}
              onChange={(event) => handleChange(event, 'code')}
              error={!!errors['code']}
            />
            <TextField
              label='Mx code'
              value={state.mx_code}
              onChange={(event) => handleChange(event, 'mx_code')}
              error={!!errors['mx_code']}
            />
          </InstructionWrapper>
        </Form>
    </div>
  );
}
